
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40.705 49.562"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Combined Shape","d":"M15.11 44.479h10.5a5.252 5.252 0 01-10.5 0zm16.39-1.906H.035L0 38.984l1.593-.313A4.53 4.53 0 005.175 35.2l.092-.438V22.834l.014-.592a14.33 14.33 0 014.634-9.917A15.294 15.294 0 0120.361 8.26 14.866 14.866 0 0135.44 22.283l.014.592v11.968l.076.361a4.53 4.53 0 003.582 3.468l1.593.313-.035 3.588zm-16.717-9.529l5.578 5.395 5.576-5.4 5.563 5.39V33.7h.013V22.917l-.009-.513a10.975 10.975 0 00-11.146-10.33 11.321 11.321 0 00-7.72 3 10.534 10.534 0 00-3.424 7.292l-.012.51v15.558l5.572-5.387h-1.569 1.57zm8.86-12.075a1.97 1.97 0 111.968 1.906 1.938 1.938 0 01-1.969-1.906zm-10.5 0a1.97 1.97 0 111.968 1.906 1.938 1.938 0 01-1.969-1.906zM31.283 8.94L27.9 6.988l2.067-3.58a1 1 0 011.365-.365L32.985 4a1 1 0 01.365 1.36l-2.066 3.58zM7.343 5.314a1 1 0 01.365-1.365L9.36 3a1 1 0 011.365.365l2.057 3.564L9.4 8.878zm14.985-.23h-3.936V1a1 1 0 011-1h1.938a1 1 0 011 1v4.082z","fill":"#011936"}})])
          )
        }
      }
    